import { Injectable } from '@angular/core';

import { DivRenderer } from '../../experimental.grid';

@Injectable()
export class GridEpicBridge {
    renderer_tab_grid: DivRenderer;
    renderer_direct_reports: DivRenderer;
}
